import { render, staticRenderFns } from "./LocationButton.vue?vue&type=template&id=2de72440"
import script from "./LocationButton.vue?vue&type=script&lang=js"
export * from "./LocationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports